import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import { store } from './store';
import { AppThemeProvider } from './theme';
import './styles.css';

const appTree = (
  <AppThemeProvider>
    {/* Force root basename to avoid redirect loops from mismatched BASE_URL */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </AppThemeProvider>
);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Provider store={store} children={appTree} />,
);
